'use client';

import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { captureCustomError } from '@/features/common/utils/sentryUtils';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Sentry에 에러 전송 (Next.js digest 포함)
    captureCustomError(error, {
      errorType: 'global_error',
      level: 'error',
      context: error.digest
        ? {
            nextjs: { digest: error.digest },
          }
        : {},
    });
  }, [error]);

  return (
    <html>
      <body>
        <div className="mx-auto flex min-h-screen max-w-screen-md items-center justify-center bg-semantic-bg-normal-normal p-4">
          <div className="w-full rounded-xl border border-semantic-line-normal-normal p-6 text-center">
            <h2 className="font-mona-sans text-body-1-semibold text-semantic-label-strong">
              Unexpected error
            </h2>
            <p className="mt-2 font-mona-sans text-label-1-normal-regular text-semantic-label-normal">
              {process.env.NODE_ENV === 'development' ? error.message : 'Please try again later.'}
            </p>
            <Button
              variant="lg-solid-alternative"
              onClick={() => (typeof reset === 'function' ? reset() : window.location.reload())}
              className="mt-4"
            >
              Reload
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
